module.exports = "/_next/static/images/service_and_support-171f776505057789ec3a9f616b2bc61f.svg";